import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const MRTPage = () => {
  return (
    <Layout>
      <PageHero
        title="Offenes MRT: Angstfrei und komfortabel untersuchen"
        subtitle="Moderne MRT-Diagnostik ohne Engegefühl – ideal für sensible Patienten."
        backgroundImage="/images/MRT Detail.webp"
        ctaText="MRT-Termin buchen"
      />

      <ContentSection
        title="Entspannte Bildgebung für höchste Präzision"
        content="Unser offenes MRT-System ermöglicht eine komfortable und stressfreie Untersuchung, die insbesondere für Menschen mit Platzangst, Klaustrophobie oder für Kinder und ältere Patienten geeignet ist. Ohne die enge Röhre eines herkömmlichen MRTs können wir hochauflösende Bilder von Ihrem Körper erstellen, um präzise Diagnosen zu ermöglichen."
        image="/images/MRT Detail.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Offenes MRT in Diez für komfortable Untersuchung"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet mit dem offenen MRT eine patientenfreundliche Alternative für die Magnetresonanztomographie in der Region Diez."
      />

      <CTASection
        title="Sie haben Fragen zum offenen MRT?"
        subtitle="Vereinbaren Sie einen Beratungstermin oder buchen Sie direkt Ihren Untersuchungstermin."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default MRTPage;
